import { WrappedFieldProps } from "redux-form";
import NumericInput from "react-numeric-input";

import {
  FormError,
  FormGroup,
  FormLabel,
  FormMeta,
  NumericInputWrapper,
} from "../styled";

interface Props extends WrappedFieldProps {
  block?: boolean;
  disabled?: boolean;
  id?: string;
  label?: string;
  margin?: string;
  width?: string;
  metaInfo?: string;
  errorOnSingleLine?: boolean;
  showErrorBeforeSubmit?: boolean;
  fieldNotTouched?: boolean;
  min?: number;
  max?: number;
  step?: number;
}

const NumberInput = ({
  disabled,
  input,
  label,
  margin,
  meta: { submitFailed, error },
  metaInfo,
  errorOnSingleLine,
  showErrorBeforeSubmit,
  fieldNotTouched,
  width,
  min,
  max,
  step,
}: Props) => {
  return (
    <FormGroup
      hasValue={input.value || input.value === 0}
      margin={margin}
      disabled={disabled}
      inline
      width={width}
    >
      {!!label && <FormLabel>{label}</FormLabel>}

      {!!metaInfo && (
        <FormMeta singleLine={errorOnSingleLine}>{metaInfo}</FormMeta>
      )}

      <NumericInputWrapper>
        <NumericInput
          {...input}
          mobile
          min={min}
          max={max}
          step={step}
          strict
          defaultValue={input.value}
          disabled={disabled}
        />
      </NumericInputWrapper>

      {(submitFailed || showErrorBeforeSubmit) && error && !fieldNotTouched && (
        <FormError errorOnSingleLine={errorOnSingleLine}>{error}</FormError>
      )}
    </FormGroup>
  );
};

export default NumberInput;
